import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { ManageNavigation } from "./components/ManageNavigation";
import { PostsReport } from "./components/PostsReport";
import { MembersReport } from "./components/MembersReport";
import { StatsReport } from "./components/StatsReport";
import { FranchisesReport } from "./components/FranchisesReport";
import { PostRewardsReport } from "./components/PostRewardsReport";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { NoAccess } from "../../components/ui/NoAccess";
import { creatorIsAdmin, isAdminOfClient } from "../../utils/adminManager";
import { apiGetComunidade } from "../../services/apiGetComunidade";
import { Loader } from "../../components/ui/Loader";
import { WIZARD_COMMUNITY_ID } from "../../constants/wizard";

export const ManageCommunity = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [comunidade, setComunidade] = useState(null);

    useEffect(() => {
        const fetchComunidade = async () => {
            try {
                setIsLoading(true);
                const data = await apiGetComunidade(WIZARD_COMMUNITY_ID);
                setComunidade(data);
            } catch (error) {
                console.error("Error fetching comunidade:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchComunidade();
    }, []);

    if (isLoading) return <Loader />;

    if (!creatorIsAdmin() || !isAdminOfClient(comunidade?.cliente)) {
        return <NoAccess />;
    }

    return (
        <Box sx={{ px: 2, mt: 3 }}>
            <Typography
                variant="h4"
                sx={{
                    my: 2,
                    fontWeight: "bold",
                    color: "var(--grey-800-color)",
                    letterSpacing: 0.5,
                }}
            >
                Gerenciar Comunidade
            </Typography>

            <ManageNavigation />

            <Routes>
                <Route path="/" element={<Navigate to="posts" replace />} />
                <Route path="/posts" element={<PostsReport title="Relatório de Posts" defaultStatus={[]} />} />
                <Route path="/membros" element={<MembersReport />} />
                <Route path="/stats" element={<StatsReport />} />
                <Route path="/unidades" element={<FranchisesReport />} />
                <Route path="/voucher-incentivo" element={<PostRewardsReport />} />
                <Route
                    path="/moderacao"
                    element={<PostsReport title="Moderação de Conteúdos" defaultStatus={["Pendente"]} />}
                />
            </Routes>
        </Box>
    );
};
